devex = devex || {};
devex.search = devex.search || {};

devex.search.Sorting = function (defaultFieldValue) {
  this.defaultFieldValue = defaultFieldValue || '';

  this.order = '';
  this.field = this.defaultFieldValue;
};

devex.search.Sorting.prototype.getParams = function () {
  var params = {
    sorting: {}
  };

  if (this.order) {
    params.sorting.order = this.order;
  }

  if (this.field) {
    params.sorting.field = this.field;
  }

  return params;
};

devex.search.Sorting.prototype.setParams = function (params) {
  if (!params || !params.sorting) {
    return undefined;
  }

  this.order = params.sorting.order || '';
  this.field = params.sorting.field || this.defaultFieldValue;
};

devex.search.Sorting.prototype.reset = function () {
  this.order = '';
  this.field = this.defaultFieldValue;
};
